import React from 'react';
import PropTypes from 'prop-types';

function ProductRatingCard({ ratingToShow,
    maxRating,
    containerClass,
    ratingUnavailable,
    backgroundColor }) {
    if (ratingUnavailable) return (<div className="product__ratings__default product__ratings__default--empty">
        <span className="product__ratings__start">★</span>
        { !maxRating && <span className="product__ratings__from">--</span> }
        { maxRating && <span className="product__ratings__from">--/{maxRating}</span> }
    </div>)
    return (<div style={{backgroundColor}} className={`${containerClass ? containerClass : 'product__ratings__default'}`}>
        <span className="product__ratings__start">★</span>
        <span className="product__ratings__to">{ratingToShow}</span>
        <span className="product__ratings__from">/{maxRating}</span>
    </div>)
};

ProductRatingCard.propTypes = {
    ratingToShow: PropTypes.any,
    maxRating: PropTypes.any,
    containerClass: PropTypes.string,
    backgroundColor: PropTypes.string,
    ratingUnavailable: PropTypes.bool
}

export default ProductRatingCard;